import { useRecoilValue, useSetRecoilState } from 'recoil';
import { onsaProgressAtom } from '../../recoil/atoms/onsaProgressAtom';
import WizardPagetemplate from '../../templates/WizardPagetemplate';
import { Box, Button, Grid, GridItem } from '@flos/react-ui';
import OnsaProgressBar from '../../shared_components/OnsaProgressBar/OnsaProgressBar';
import { topConfigContextAtom } from '../../recoil/atoms/topConfigContextAtom';
import type { WizardPageComponent } from '../../config/wizardPagesConfig';
import useWizardNavigation from '../../hooks/useWizardNavigation';
import { jobInfoAtom } from '../../recoil/atoms/jobInfoAtom';
import { getOnsaProgressSelector } from '../../recoil/selectors/getOnsaProgressSelector';

const CustomerIdentificationPage: WizardPageComponent = () => {
    const { wizardNextStep, wizardGotoStep } = useWizardNavigation();
    const setOnsaProgress = useSetRecoilState(onsaProgressAtom);
    const onsaNavigation = useRecoilValue(getOnsaProgressSelector);
    const topConfigContext = useRecoilValue(topConfigContextAtom);
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);

    const goNext = (): void => {
        wizardNextStep();
    };

    const goPrevious = (): void => {
        setOnsaProgress((prevStep) => ({
            ...prevStep,
            currentStep: prevStep.currentStep - 1
        }));
        wizardGotoStep(onsaNavigation.prevStep);
    };

    const startLogonPopupWindow = (): void => {
        if (topConfigContext?.loginClient?.startPopup) {
            topConfigContext.loginClient.startPopup({
                appName: 'top-online-sales',
                targetUrl: `${topConfigContext.loginRedirectUrl}/?onsastep=CoveragePackagePage&jobId=${jobNumber}&sessionId=${sessionId}`
            });
        }
    };

    return (
        <>
            <OnsaProgressBar />
            <WizardPagetemplate hideNext onPrevious={goPrevious}>
                <Grid>
                    <GridItem span={8} colStart={3}>
                        <Box padding="large" className="u-spacing-stack-l">
                            <Box className="u-bg-supplement-grey-light flos-box--center-children u-shadow-none">
                                <img
                                    alt="MitID"
                                    src={`${topConfigContext?.resourceUrl ?? ''}/images/mitid.svg`}
                                />
                            </Box>
                            <div className="u-spacing-inset-m--stretch-max">
                                <h4>Færdiggør beregning</h4>
                                <p>
                                    For at kunne beregne din samlerabat, har vi brug for at du
                                    logger ind med MitID - du kan også vælge at fortsætte uden at
                                    logge ind, men så kan vi ikke beregne din samlerabat.
                                </p>
                            </div>
                            <Grid>
                                <GridItem>
                                    <Button
                                        minWidth="wider"
                                        onClick={() => {
                                            startLogonPopupWindow();
                                        }}
                                    >
                                        Log ind med MitID
                                    </Button>
                                </GridItem>
                                <GridItem>
                                    <Button minWidth="wider" onClick={goNext} theme="ghost">
                                        Brug CPR-nummer istedet
                                    </Button>
                                </GridItem>
                            </Grid>
                        </Box>
                    </GridItem>
                </Grid>
            </WizardPagetemplate>
        </>
    );
};

export default CustomerIdentificationPage;
